import { IEquipment } from '../../../../equipment.types.ts'
import { ISVGSettings } from '@/pages/Dashboards/Charts/SVGChart/svgChart.types.ts'
import { IParameter } from '@/pages/Parameters/parameters.types.ts'

const liftCardSvgSettings = (
  equipment: IEquipment,
  sourceIdToIdMap: Record<IParameter['sourceId'], IParameter['id']>
): ISVGSettings => {
  const isLkdsProtocol = equipment.protocolId === 'lkds'

  const floorParameterId = isLkdsProtocol
    ? sourceIdToIdMap.currentStop
    : sourceIdToIdMap.currentLevel
  const directionParameterId = isLkdsProtocol
    ? sourceIdToIdMap.elevatorMovementUp
    : sourceIdToIdMap.displayCarDirection
  const leftDoorParameterId = isLkdsProtocol
    ? sourceIdToIdMap.doorsOpened
    : sourceIdToIdMap.VKZDoorSideASgl
  const rightDoorParameterId = isLkdsProtocol
    ? sourceIdToIdMap.doorsOpened
    : sourceIdToIdMap.VKZDoorSideBSgl
  const doorMovementValue = isLkdsProtocol ? 0 : 1

  return {
    text: [
      { parameter_id: floorParameterId, device_id: equipment.id, node_id: 'floor' },
      { parameter_id: directionParameterId, device_id: equipment.id, node_id: 'direction' },
    ],
    color: [],
    title: '',
    image_id: '1d8cb757-828d-45ec-9c94-21e33bea8399',
    movements: [
      {
        type: 'movements',
        parameter_id: leftDoorParameterId,
        value: doorMovementValue,
        device_id: equipment.id,
        node_id: 'leftDoor',
        condition: '=',
        cycle: false,
        direction: 'right',
        distance: 82,
        duration: 0.5,
        hide_self: false,
        rotate_one_way: false,
      },
      {
        type: 'movements',
        parameter_id: rightDoorParameterId,
        value: doorMovementValue,
        device_id: equipment.id,
        node_id: 'rightDoor',
        condition: '=',
        cycle: false,
        direction: 'left',
        distance: 82,
        duration: 0.5,
        hide_self: false,
        rotate_one_way: false,
      },
    ],
    rotations: [],
    visibility: [],
  }
}

export default liftCardSvgSettings
